var map = {
	"./bad_smell.svg": "6a31",
	"./cleaned_floor.svg": "9fe7",
	"./cleaned_mirro.svg": "f219",
	"./cleaned_shower.svg": "e080",
	"./cleaned_sink.svg": "65eb",
	"./cleaned_stainless_steel.svg": "3aae",
	"./cleaned_toilet.svg": "35ca",
	"./cleaner.svg": "97fe",
	"./cleaner_arrived.svg": "09bc",
	"./cleaning.svg": "87b7",
	"./coffee_tea.svg": "e329",
	"./counter.svg": "3327",
	"./counter_handycap.svg": "f5aa",
	"./counter_men.svg": "4c96",
	"./counter_woman.svg": "8dac",
	"./dirty_floor.svg": "36cb",
	"./dirty_lavatory_seat.svg": "f0dd",
	"./dirty_mirror.svg": "660b",
	"./dirty_shower.svg": "e20c",
	"./dirty_sink.svg": "c64a",
	"./dirty_stainless_steel.svg": "8f99",
	"./disposable_dishes.svg": "b8e6",
	"./english.svg": "2ff5",
	"./español.svg": "7bd4",
	"./excellent.svg": "b895",
	"./fixed_blockage.svg": "8f4d",
	"./fixed_broken_toilet.svg": "b52c",
	"./fixed_door.svg": "047e",
	"./fixed_fluid_taps.svg": "7c65",
	"./fixed_lightning.svg": "5ab2",
	"./fixed_mirro.svg": "9c1f",
	"./fixed_shower.svg": "de74",
	"./fixed_sink.svg": "fe6b",
	"./fixed_stainless_steel.svg": "8e4b",
	"./français.svg": "2fea",
	"./full_garbage_can.svg": "1eed",
	"./good.svg": "28fa",
	"./italiano.svg": "31e8e",
	"./light.svg": "f3d3",
	"./like.svg": "0806",
	"./maintenance.svg": "00a1",
	"./maintenance_fixed.svg": "bb40",
	"./maintenance_problem.svg": "1cf2",
	"./missing_paper_towel.svg": "1330",
	"./missing_soap.svg": "d7ef",
	"./missing_toilet_paper.svg": "06c6",
	"./needs_Improvement.svg": "a181",
	"./not_good.svg": "beb2",
	"./paper_towel.svg": "8c31",
	"./português.svg": "d34c",
	"./problem_blockage.svg": "fd05",
	"./problem_broken_toilet.svg": "0ae5",
	"./problem_fluid_taps.svg": "8a09",
	"./problem_lightning.svg": "7a34",
	"./problem_mirro.svg": "b81c",
	"./problem_paper_dispenser.svg": "bf84",
	"./problem_shower.svg": "5087",
	"./problem_soap_dispenser.svg": "be74",
	"./problem_stainless_steel.svg": "15c0",
	"./taps.svg": "8c0a",
	"./toilet_seat.svg": "8f5a",
	"./very_good.svg": "4a48"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "11bf";